import {
  AdFormat,
  AdType,
  CallToAction,
} from "screens/adLibrary/facebookUtils/types";
import { PreviewSizes } from "./types";

export const MOBILE_WIDTH = 335;
export const DESKTOP_WIDTH = 502;

export const previewSizes: PreviewSizes = {
  DESKTOP_FEED_STANDARD: {
    Carousel: { width: DESKTOP_WIDTH, height: 615 },
    Still: { width: DESKTOP_WIDTH, height: 690 },
    Video: { width: DESKTOP_WIDTH, height: 820 },
    Collection: { width: DESKTOP_WIDTH, height: 655 },
    InstantExperience: { width: DESKTOP_WIDTH, height: 615 },
    // TODO: handle AIA previews
    AIA: { width: DESKTOP_WIDTH, height: 715 },
    DPA: { width: DESKTOP_WIDTH, height: 715 },
    FTA: { width: DESKTOP_WIDTH, height: 715 },
  },
  MOBILE_FEED_STANDARD: {
    Carousel: { width: MOBILE_WIDTH, height: 565 },
    Still: { width: MOBILE_WIDTH, height: 565 },
    Video: { width: MOBILE_WIDTH, height: 680 },
    Collection: { width: MOBILE_WIDTH, height: 775 },
    InstantExperience: { width: MOBILE_WIDTH, height: 565 },
    AIA: { width: MOBILE_WIDTH, height: 715 },
    DPA: { width: MOBILE_WIDTH, height: 715 },
    FTA: { width: MOBILE_WIDTH, height: 715 },
  },
};

export const mockStillAd = {
  id: "23848368169380366",
  name: "2021_Oct_Ford of Latham_WebConv Used_In-Market Used_All Placements_Cinemagraph_Pre-Owned CR",
  campaign_id: "23848368167090366",
  adset_id: "23848368167910366",
  creative: {
    object_story_spec: {
      page_id: "126521100757173",
      instagram_actor_id: "2007345015999815",
      link_data: {
        title: "Tap to Explore Our Pre-Owned Inventory",
        message:
          "Looking for a pre-owned vehicle? Discover our wide selection of pre-owned vehicles at Ford of Latham! Contact us today.",
        call_to_action: {
          type: CallToAction.SHOP_NOW,
          value: {
            link: "https://www.lathamfordmotors.com/used-inventory/index.htm",
          },
        },
        picture:
          "https://www.facebook.com/ads/image/?d=AQLiOfGNWW9YCPLWt7Lr5g7nVZKtb2ec4DE3GRXUEaXY722K-onnfoyeAV-v_dix080IUDEuVpAL3kx8vKzV8NKFsBcYQ8DLaNlLzLPrpKoVPWWW3r2juRBWpOzC8UKcBRDpbs31b4Xnqnm-NHR9ZP8g",
        image_hash: "4f8ec034b6e56f543ee85aeb185280d5",
      },
    },
    id: "23848368170820366",
  },
};

export const mockVideoAd = {
  id: "23848368169380366",
  name: "2021_Oct_Ford of Latham_WebConv Used_In-Market Used_All Placements_Cinemagraph_Pre-Owned CR",
  campaign_id: "23848368167090366",
  adset_id: "23848368167910366",
  creative: {
    object_story_spec: {
      page_id: "126521100757173",
      instagram_actor_id: "2007345015999815",
      video_data: {
        video_id: "350595406153062",
        title: "Tap to Explore Our Pre-Owned Inventory",
        message:
          "Looking for a pre-owned vehicle? Discover our wide selection of pre-owned vehicles at Ford of Latham! Contact us today.",
        call_to_action: {
          type: CallToAction.SHOP_NOW,
          value: {
            link: "https://www.lathamfordmotors.com/used-inventory/index.htm",
          },
        },
        image_url:
          "https://www.facebook.com/ads/image/?d=AQLiOfGNWW9YCPLWt7Lr5g7nVZKtb2ec4DE3GRXUEaXY722K-onnfoyeAV-v_dix080IUDEuVpAL3kx8vKzV8NKFsBcYQ8DLaNlLzLPrpKoVPWWW3r2juRBWpOzC8UKcBRDpbs31b4Xnqnm-NHR9ZP8g",
        image_hash: "4f8ec034b6e56f543ee85aeb185280d5",
      },
    },
    id: "23848368170820366",
  },
};

export const mockCollectionAd = {
  id: "23848368176500366",
  name: "2021_Oct_Ford of Latham_WebConv Used_In-Market Used_All Placements_Collection_Used Inventory MO1",
  campaign_id: "23848368167090366",
  adset_id: "23848368167910366",
  creative: {
    object_story_spec: {
      page_id: "126521100757173",
      video_data: {
        video_id: "334197067945153",
        title: "Tap to Explore",
        message:
          "Searching for a great deal on the perfect pre-owned vehicle? We have a wide selection and competitive pricing.",
        call_to_action: {
          type: CallToAction.LEARN_MORE,
          value: {
            link: "https://fb.com/canvas_doc/147321960566701",
            link_format: "VIDEO_LPP",
          },
        },
        image_url:
          "https://s3.amazonaws.com/alexia-assets-prd/assets/af8b98bc-689e-46c4-9ef3-e4fe91383627.jpg",
        image_hash: "f3b2778b6e0c2ce2fd5ce34a7f394b1e",
        retailer_item_ids: ["0", "0", "0", "0"],
        post_click_configuration: {
          post_click_item_headline:
            "{{vehicle.year Aa}} {{vehicle.make Aa}} {{vehicle.model Aa}}",
          post_click_item_description: "At {{vehicle.dealer_name}}",
        },
      },
    },
    product_set_id: "626955308192224",
    id: "23848368178840366",
  },
};

export const mockCanvasAd = {
  id: "23848368175110366",
  name: "2021_Oct_Ford of Latham_WebConv_In-Market_All Placements_Canvas_Shop Online MT1",
  campaign_id: "23848368167060366",
  adset_id: "23848368167630366",
  creative: {
    object_story_spec: {
      page_id: "126521100757173",
      video_data: {
        video_id: "3117912181610362",
        title: "Discover Now",
        message:
          "Looking for a new car? Start your buying process from the comfort of your own home.",
        call_to_action: {
          type: CallToAction.LEARN_MORE,
          value: {
            link: "https://fb.com/canvas_doc/3651871628236557",
          },
        },
        image_url:
          "https://www.facebook.com/ads/image/?d=AQJD15kB6N386SZPq_mmnSyDlhwoNPmSZDy39MTfNIQDink95OAQyZO-v0hC9xcR0UyqW6riP9sUiUhF6QwILI88FTnxZJguBtn288AVmOc_GaBCDlwpH24s4vZgoWgb7yZ1x0-UNu_LOOn0zFh0P9rU",
        image_hash: "121ae22f9b3c21724a6f6ef68fe8ef3e",
      },
    },
    id: "23848368178440366",
  },
};

export const mockCarouselAd = {
  id: "23848368169670366",
  name: "2021_Oct_Ford of Latham_WebConv_In-Market_All Placements_Carousel_MY21 Explorer",
  campaign_id: "23848368167060366",
  adset_id: "23848368167630366",
  creative: {
    object_story_spec: {
      page_id: "126521100757173",
      link_data: {
        message: "The 2021 Ford Explorer is primed for modern-day exploration.",
        call_to_action: { type: CallToAction.SHOP_NOW },
        child_attachments: [
          {
            link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
            image_hash: "8403fe0033bef74627dd18cbdf50f382",
            name: "Athletic Build",
            call_to_action: {
              type: CallToAction.SHOP_NOW,
              value: {
                link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
              },
            },
            video_id: "689738085041611",
          },
          {
            link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
            image_hash: "b4e8234a52011f193bc788cf31f9f3b3",
            name: "Comfort and Capability",
            call_to_action: {
              type: CallToAction.SHOP_NOW,
              value: {
                link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
              },
            },
            video_id: "857160878419443",
          },
          {
            link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
            image_hash: "97d7e8aa6aa6e26a4da9aaecc789aaf8",
            name: "Adventure Awaits",
            call_to_action: {
              type: CallToAction.SHOP_NOW,
              value: {
                link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
              },
            },
            video_id: "318505736169491",
          },
          {
            link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
            image_hash: "7736a2d649a0082e0b9d48eef3485c00",
            name: "Shop Online Today",
            call_to_action: {
              type: CallToAction.SHOP_NOW,
              value: {
                link: "https://www.lathamfordmotors.com/new-inventory/index.htm?search=&model=Explorer",
              },
            },
            video_id: "401923700895793",
          },
        ],
        multi_share_end_card: false,
        multi_share_optimized: false,
      },
    },
    id: "23848368171550366",
  },
};

type MockPreviewRec = Record<AdType, string>;
type MockPreviewEntry = Partial<MockPreviewRec>;
type MockPreviewByFormat = Record<AdFormat, MockPreviewEntry>;
type MockPreviews = Partial<MockPreviewByFormat>;

export const mockPreviews: MockPreviews = {
  DESKTOP_FEED_STANDARD: {
    Carousel:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQJ0IyDogknLSZtCgsZaR-WtZKcbznBvQD6keOehdSiiGnbz8k1hBU84j0j8l-NFIk6uvveKQBazvY0DNyO54gx1gkdTv1t3Auvo6tittxQfDn_NVt8VTClaAr4U5wkrmWSG8q_3V-bZH2_J1m98txGV1UTuTZhmccbAWW54dUQ6XTSWWglxd-IVDRDWDr-BpURviUsUvo7YGyXrCZ47Y_Ys1CksEzy83H2G3jgaeQPQo-LjM-ehTzjdyMEcQ4p_rRgt4LBGcaWWGzNETxdvexl9djJkyRor11mgIZX2XxIwZxpVeREOMPNS7R4RySFRtKbMl22jG8z_9Np8cX6b4TgxQ20R4EqbFK3rPR6kejSDww&amp;t=AQIqsmXHKIHRUa7hmB0" width="540" height="690" scrolling="yes" style="border: none;"></iframe>',
    Video:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQL6I7i5zbv1LVdWhFZh-RSamLH3flxUqBudo6QOnKdv8sSxVa5jEsfc4Gs_AeEl0EHSIGW6-1PbRynLhMQCy4SqWhTdN04tiGYhCXqql-nInLWCL9KO7eAqDdHMh0YgxYhO58FsuIvQ4HEusODLTVtO01uGrHST2y4d1X9YpC0txn48VIXFl-02ZbIoDq6QVskcP7xOcPefxXe5D4h1H2EBiHjOrk5-VVrWiKzLB23T88-cOw24W41gQUSFsnoxzdFqr2TrDwhjVt0Ya05IdChmVPRVD-azGWosAzsrZMZj7vHFpSa7JfB04bQBttO0R1MWfLidqTarSxbCjb_7i4X_cWJ6TgwGBtHYjZfTxw4gEw&amp;t=AQLrjvCDNFsRuUg6WvI" width="502" height="690" scrolling="yes" style="border: none;"></iframe>',
    Still:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQKkDaY7k9O37NmDxN4k-NjmeMiLUQcizcWZ8FA7h3gD0KLNF63tw4HsiawPNqqCyMDpBGaQD9_CU1GpscV6IlEoF4YEv1Aie9ke9gaUCz92DDh2w7q6UiQ-ulISJHg6b5mVbUiwCx4gFEtHMDLUUcaXGyPmy7hplFYZ_xQpZVmh72fhlsfUpDdCsjfeOqEgw_2dWdp3ILuZGnbADhRc3J0GhmAp0FuxtGt2pXKQTFrrE0ywqefEuz6gLhy57eO8_cH5w0UvlRCn3mFb8ZOIXeG3O2StoJ82LuIT6DWQC29Hk3YybI-2mTm1pTcUOzxZqTKuJq2CvAQhIv9qvwFXkv1PGiYtuW1mrHsnJ6TA4aWWmUBqoxwGBvaV1yIS0mA3fG4P9L8khWf7pANVt4McYO0JUIFSc00QqrhsOBdkaCWvD1KVENWWa85p95tWJHqLx8U6tEK7nNNWVhkKbgNmAO45ympGYTTY-o6H_6M8vn42O1TAlScJOEvbiKGQZY6mNaWeTWmiRkLSoWRXG7KSlLgcrRAtRwzw5BWx1wOaM47VDAqaDl250a-roYJV8MlXYxPOOVmhkZID88m38ualPrcK1NPLUg8UAB5IC_n1TPGjcPASDwrpYfTV_SaMCPI3g2SBKYg68PckKWhDpXRL0xsgxljmDjZXXZ4XEtog-vNIJYnNKr25bygbd_wpp4ED-9KOncjLzksUVSa6pE2KErvgI4CwTjAPFWRpMtHDGQRyUyNlwJIYvOFBjX1C8hRCOH7GRpSUq6Gy_45xRQ55FLgqWXmYeOwYMXbdChvXotOYt4YWlCPno7mNXboUgul2FLJS0N_hrCXxf1FphxmTVPTB4cnebosYXzIfw6YPsNd5EujL6v7f1M5kwagqzULLZCJjF_iOQvdQpmQICBqMl0joJMfQ36jE3nP3XgP95lss-L5LLJlU7HRDWO7fz8wzaODDKsC_OFu0iEFE5C0LDxr-EX3I9C57VsIguBTbK6hGF11AxYuxakd1NdVWFYJfseni0o_TfjdWVCfPptWdrxbs1spJGIzwxcEuhycuvcUO3H092s5mYcUXwhWM7qj648tuM2wa3V8dmqN_Xb_BFORfRxgsdfTJDv9Gxgp96OYr02OMdXpQ6Z5mWvBQg8GU_ZAjhPsVmaEsAroMJ10uDPKSHsONvYKUJcfR_-vQXAsZuCyHKXWb2JOiJ-sbVWqlpnGl_P03L5mxHKcnE2YrP1hf0RJdICVqmSEzBFA6R1lvDZexijrs3EOQAW-Q8oonSL_ZHiPFhwDSSLvJL01VDNXwnIvt7CWVzeUxWjVdlJlbowjrTVTvf4SPu2hbZC6lkcRNCw-GiZRaCiDvHzaSu0ueGU-R2FZ2mJtS4EIqR0zcet1MRur42op9wZXGPhEwIMz86koikrTAtSP0g5v3FS_FgkF6vfFpjfyHOX-Pq-Zaiiphkq6K2bVvBAyouzR9mWSnTO308qYoDCUj6EXOJoFslSD-2vUB_jKYQmLAh9KJU8JQUjupBH64-RbR6tqKmwE1Jt10Lkj_bCf7277UUjXosJ1AJrS8h_5wT-d1nKUXKLn1kP13aWuFdk0Qi33-mr0tzOOeZWq9ann2jiDlDCqlEew72207HbMgPF8LTHbXH8CU8eLJFcTTGWPm91erbNx7roe9m3OI4YkCt-n6LL-2bnUau6VVHEQfIZn0pfZWUot5Xg7ucj0gaU7p_4Lz7rbIbi-n7HZjhn6CCd4IY8l2QwWRbxUjK8zJw8fHJ73EktQDdj4_-W4r63R76PmEld8GAfgWq_QOIyPEo-BLczuOUd3qaK7DDOKo35tcsVmN5_K2ozNJ9RCV-S8u8pMlL9qMTjpQv4JBPXue9xiIpELcP-I4Ery3bmOVz5xG0AdX9TdeiF1W_7oHPiWDbWs9u58&amp;t=AQJ5v-hyyU2UYiDBRBo" width="540" height="690" scrolling="yes" style="border: none;"></iframe>',
  },
  MOBILE_FEED_STANDARD: {
    Carousel:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQJbPxijj5iZNrc5aM0lXvf8_27UhV1VzFCZ2199C30CU-pirjIYBOHDHZpFrjaaPdvglJAk3R8eEYsSnAB643JvP5dYpAGLK2aEcHhUV2aO9lbyVhu9lqU6UoHnFH_A2SKrp8LcPqvg2VqfL3qFrBxGCbGGuqAY0Jt10FbxFV9_Z5Wf__QsjU71b79iZBIbb-s6lqdz5JaFZjaNxnwaLx1dfzAPIZeSBQth2EgShI0eyoyIsqxPS8lWGUH6nKbr83BmgNrWsvWLaGMuluxgUsPZBVh2RD4RGV5UZvmgnPBiBtuSN_4hYowyYVe0CK2A97bMspoioXdY7k9LtetD24kf&amp;t=AQJGPKwT4kIdYrKJAD8" width="335" height="450" scrolling="yes" style="border: none;"></iframe>',
    Collection:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQJlzyqIN3v0cY8ye9TKXkHo_2IFKJzQ9GaqLpiwvWFau7539h_XB3STiYlNHnCuFzNUvq0x8VipJCXTS39Z-05lMvrnRXmBKjqMPXZI-QQmXyLEVLqc6sD9Fl418a89H6gxH-FZmxa1koRLhoi0p-40hiWPJFoHiFpg-Dr8pu8K5xaXnJaBZ_fywqRU8VT9Ar8ZkcXyBJZK5ADwy_76NWeNNzo7Q4BRKwA-20u94ZIVjMZvqQTGPTJuz1quY8QOaO1Zh_401uZ6wwi0NdYffCxFoWcrSvldKaY86iNnHj6kyOz38bqEcdJ4dlM-vkgfyRVytwiOs_Q1JE1AlUy-E64s&amp;t=AQKfJ0Rf31MZxzHAgRo" width="335" height="450" scrolling="yes" style="border: none;"></iframe>',
    Video:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQKDKczjFlRefFDE3HZluzKrpYGRDpkEiZ_djR7EyoG9_wNEH5rW3C_sQABm9xfmvdWpOdq3NnAfhCFCTe_jX1XCg4ZIVAW1RWAh8Z4vmjGyJltm-bOyHFYa7bSnWAqJBTx1sBPKWZpfIAWgZLcP4uHT92h0ZvKYkTtsDS-dFzr0jjwhV392z4jDK19aX1-uyPHAFvtmuLslL73LflWUOBxGts0L3n1SmmPyud3O52Hbp8W70Jd9J4ljetgyDKJbNB_iuVRrQxLLpefqEx6NjaJEvTVhyWwvgz3RVdeJkVM7QLA6uB9JVbTqOweooMgyxwTwQ3WtGAbLTqTbSWSV5lYy&amp;t=AQLa-5DSBdZyVtQvvI8" width="335" height="450" scrolling="yes" style="border: none;"></iframe>',
    Still:
      '<iframe src="https://www.facebook.com/ads/api/preview_iframe.php?d=AQKxbCu574NWr7cYg3agCGRLxae1g2S8mNvaUGRk_L41rH45biu7K0jckfJSQXo2WmzkOF4srJbOuxCPlluWsV8zpq3frUlTVeD6tr1j9n3CFuUjeiYvJPHxAosCNeUfrstj6GaosGC1NDTngOLO9W-bWl_dRAvyvL5Q1-mRbl4I4E-1hJ_9zByj3BE2lZWfX3rIqDR45s5nY20w_LwcmG7yglHYg70msXCOdYBC1fEQlmcER0OhuZ1yLxp4czMrdBiUL3N9TqYDZyg_IOmCMixVIw5D-C_Jk6vHLIeDcqqvbkX8OKaum4pXqus9mD3Ovxpe6I846F1JFWjplCuQUWIzKuAxNAyVMPST9LpAE6Uiahp_ULPaeYfzX-g4f7J46OBZ3j4yco3XPyXylSJ0Zin_4OVkUahjqTslcP_Ev-Wg1TloBs4tBehbTpdTmgktqiyAs5KX13A3SRL6wgkv8z28bgWgz0El1uDqXYb-_H245u5Cymj-QczdOkeaHcpG_8nprUA5ivROxvrVMsZbXWjB7NnKzmM2EraqwKzIzZFGKsRi07N8gQ7MT740H19LuZjpZMoXdTOvnD5RDvh5UiKNG56YCS8Gw4qusByYr4Z1q8sOuoucvJLONciqJHNwWzYCwE6esJ6bTpbAob_2goy7uktKfi7rMFabrfV_fyrD4SwntM-yUlbPsu7dyHRgV0qgm0-Xg1hc2mg-pMM2zqVizQHHzpwtOK8fUiJ0-INoZQIPlK_abpypCVASfphv3ToOwooTjyOJgJIp7cFHJdfeTrrhFpu1pNY9l9N5owSzM2ooczgAon-7CbBRnZLr8K5aeGWCfgC_Kw5H0FZVZG_uPj4hBpr00fEOKpleJwhyX3QtHDqQ3GFCV3IL53W4GYT8F6ckdnd3mMTNyeBytQunzLQ0Fph_soMXm8vBYxNNA6KN_yrW8ma96YLI3AYAZDh_mZ48bryN_lqvAqadbbUOd_YMHiiDPhxUeswYxFNup266nLejcu3GCLTx-IW5QEaJZbFXnY-V0dhKpdAdWTZXP6aVgRz9mVdBgjaYJX6qRma4BdEMnnF8mt2sK3g8Xl9D_N819MkkphTVusIo4d3WcD4feYQ0GhBbU3T2vSdz8xkx_P-KTuV-MAsA99qy7gbLTWz6mkZi53YB-WYRUeLPlFvmHx4zNrmFG_K9i0dCFTsI1zfIZR2LgB6w0vx8LTLYm-155crMTSKHwjGGoHkUFH12-lX7fIh03f_auIL-jFvcpaqHayrbQ89h7rEdhAhSSfPobFQLZwBNmjK7214LbdoxRnM7ZRsBS1s5QLLZPh_eJCCFq-PdD-j33Am4HtNHvUtRdBTTbeQv0k4n5jzPaxfH_0K2XaK-I1YJbboGeTXgk676NLnTCk1gALfW6rgxspAwXCrd5JGg9428KmC2uYWH-q6CUITpPc-ECDpX6u40U0_wTUz_W7P0OBhXCrj_tu8O2pFNVP2JRg6svRFNAa6KT5I9gy_e1RxhzT3ZLPNUU6ERMEokp3HTvlxPoNR7iWOIww2seg2YVA5LAYMfe0wpej9tefQtX114dA6wmy6FRLNldRBCdU2Yz6qYQyimILo1Y0R4pfIQ5vFTfVSa0PaFsTYtb0g6IFN2io9uyvF6tHtPGShg_Wy0K7QF_M-nK6mnUkCZ_GDCjbzsgY5nAEAdvle9YwwvQbE-ttIypycFOFoqsnQc-K6kw-Wqz1qPmBDaBphnD2qRzKk2ZaR0TlOG6c_bhwScXUiOzFaehls0qSO2fd2hCcUW3dlfiUn2j94a2CC8Kf8EA7i-TvuNbR0pFkTAEs2UkJnqQHDV4NzX-rrAWvOa0P4-HPihRdfl-SgMz2q-Ao07lm0AvojxQqR40McD853i07HBkdr9jnE8_wnr-OWZPEhX1vU449s&amp;t=AQJvX7nkWhk-hlDzM1w" width="335" height="450" scrolling="yes" style="border: none;"></iframe>',
  },
};
